import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'

const Controls = function(camera, renderer) {
// https://threejs.org/docs/#examples/en/controls/OrbitControls
  let controls = new OrbitControls(camera, renderer.domElement)
  controls.update()
  controls.enableDamping = true
  controls.damping = 0.5
  controls.minDistance = 50 // min zoom distance to prevent to "go inside object"
  controls.maxDistance = 1000 // max zoom distance
  controls.enablePan = false // dont enable to move the camera away from center
  controls.autoRotate =  true // https://threejs.org/docs/#examples/en/controls/OrbitControls.autoRotate
  controls.autoRotateSpeed  =  3.0
// controls.enableZoom = false;
// controls.minPolarAngle = 0; // from top
// controls.maxPolarAngle = 2.4;
// controls.dampingFactor = 0.07;
// controls.rotateSpeed = 0.07;
  return controls
}

export default Controls